/**
 * Analytics - Booking Funnel Events
 *
 * Tracks every step of the 3-step booking flow so funnel drop-off
 * can be measured in GA4.
 *
 * Step numbers: 1=offerings, 2=schedule, 3=confirm
 * Sources: 'popup_modal' (HomePageMap) | 'inline_panel' (EntityDetailMap)
 */

import { trackEvent } from './core'

const CAT = 'Booking'

/** Funnel opened (modal/panel mounted). */
export const trackBookingFunnelOpen = (entityId, entityName, source) => {
  trackEvent(CAT, 'funnel_open', entityName, null, { entity_id: entityId, source })
}

/** Each step becomes visible. */
export const trackBookingStepView = (step, stepName, entityId, source) => {
  trackEvent(CAT, 'step_view', stepName, step, { entity_id: entityId, source, step_name: stepName })
}

/** User selected an offering. */
export const trackBookingOfferingSelected = (entityId, offeringId, offeringName, price, source) => {
  trackEvent(CAT, 'offering_selected', offeringName, null, {
    entity_id: entityId, offering_id: offeringId, price, source,
  })
}

/** User clicked Next / advanced a step. */
export const trackBookingStepAdvance = (fromStep, toStep, entityId, source) => {
  trackEvent(CAT, 'step_advance', null, null, { from_step: fromStep, to_step: toStep, entity_id: entityId, source })
}

/** User clicked Back. */
export const trackBookingStepBack = (fromStep, toStep, entityId, source) => {
  trackEvent(CAT, 'step_back', null, null, { from_step: fromStep, to_step: toStep, entity_id: entityId, source })
}

/** Scheduling type toggled (single / flexible). */
export const trackBookingSchedulingType = (type, entityId, source) => {
  trackEvent(CAT, 'scheduling_type', type, null, { entity_id: entityId, source })
}

/** Send Request clicked. */
export const trackBookingSubmitAttempt = (entityId, offeringId, schedulingType, source) => {
  trackEvent(CAT, 'submit_attempt', null, null, {
    entity_id: entityId, offering_id: offeringId, scheduling_type: schedulingType, source,
  })
}

/** Booking created successfully. */
export const trackBookingSubmitSuccess = (entityId, offeringId, schedulingType, source) => {
  trackEvent(CAT, 'submit_success', null, null, {
    entity_id: entityId, offering_id: offeringId, scheduling_type: schedulingType, source,
  })
}

/** Booking request failed. */
export const trackBookingSubmitError = (entityId, offeringId, source) => {
  trackEvent(CAT, 'submit_error', null, null, { entity_id: entityId, offering_id: offeringId, source })
}

/** Funnel closed before completing (abandon). */
export const trackBookingAbandoned = (entityId, atStep, source) => {
  trackEvent(CAT, 'abandoned', null, atStep, { entity_id: entityId, at_step: atStep, source })
}
